import Vue from 'vue';
import Router from 'vue-router';
import ListTicket from '@/components/ListTicket';
import Login from '@/components/Login';
import CloseTicket from '@/components/CloseTicket';
import FilteredListTicket from '@/components/FilteredListTicket';
import Location from '@/components/ListLocation';
import TicketPerDay from '@/components/TicketPerDay';
import AvgTicketTime from '@/components/AvgTicketTime';
import HourlyReport from '@/components/HourlyReport';
import AddUpdateStationLocation from '@/components/AddUpdateStationLocation';
import ListStationLocation from '@/components/ListStationLocation';
import AddStation from '@/components/AddStation';
import ListStations from '@/components/ListStations';
import RecentClosedTickets from '@/components/RecentClosedTickets';
import AddUserLocation from '@/components/AddUserLocation';
import ListUserLocation from '@/components/ListUserLocation';
import TvScreen from '@/components/TvScreen';
import TicketWaitingWindow from '@/components/TicketWaitingWindow';

Vue.use(Router)

export default new Router({
    mode : 'history',
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/reports',
            name: 'ListTicket',
            component: ListTicket
        },
        {
            path: '/closeticket',
            name: 'CloseTicket',
            component: CloseTicket
        },
        {
            path: '/',
            name: 'CloseTicket',
            component: CloseTicket
        },
        {
            path: '/filterreports',
            name: 'FilteredListTicket',
            component: FilteredListTicket
        },
        {
            path: '/location',
            name: 'ListLocation',
            component: Location
        },
        {
            path: '/ticketperday',
            name: 'TicketPerDay',
            component: TicketPerDay
        },
        {
            path: '/avgtickettime',
            name: 'AvgTicketTime',
            component: AvgTicketTime
        },
        {
            path: '/hourlyreport',
            name: 'HourlyReport',
            component: HourlyReport
        },
        {
            path: '/addupdatestationlocation',
            name: 'AddUpdateStationLocation',
            component: AddUpdateStationLocation
        },
        {
            path: '/updatestationlocation/:id',
            name: 'UpdateStationLocation',
            component: AddUpdateStationLocation,
        },
        {
            path: '/liststationslocations',
            name: 'ListStationLocation',
            component: ListStationLocation
        },
        {
            path: '/addstation',
            name: 'AddStation',
            component: AddStation
        },
        {
            path: '/updatestation/:id',
            name: 'UpdateStation',
            component: AddStation
        },
        {
            path: '/liststations',
            name: 'ListStations',
            component: ListStations
        },
        {
            path: '/recentclosedticket',
            name: 'RecentClosedTickets',
            component: RecentClosedTickets
        },
        {
            path: '/ticketwaitingwindow',
            name: 'TicketWaitingWindow',
            component: TicketWaitingWindow
        },
        {
            path: '/adduserlocation',
            name: 'AddUserLocation',
            component: AddUserLocation
        },
        {
            path: '/updateuserlocation/:id',
            name: 'UpdateUserLocation',
            component: AddUserLocation
        },
        {
            path: '/listuserlocation',
            name: 'ListUserLocation',
            component: ListUserLocation
        },
        {
            path: '/tvscreen',
            name: 'TvScreen',
            component: TvScreen
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js